export default __webpack_public_path__ + "static/media/star1.89aaebfa.svg";